export const dataTemplateConstants = {
     DATA_TEMPLATE_LIST_REQUEST: "DATA_TEMPLATE_LIST_REQUEST",
     DATA_TEMPLATE_LIST_COMPLETE: "DATA_TEMPLATE_LIST_COMPLETE",

     DATA_TEMPLATE_GET_ALL_SCHEMA_LIST_REQUEST:
          "DATA_TEMPLATE_GET_ALL_SCHEMA_LIST_REQUEST",
     DATA_TEMPLATE_GET_ALL_SCHEMA_LIST_COMPLETE:
          "DATA_TEMPLATE_GET_ALL_SCHEMA_LIST_COMPLETE",

     DATA_TEMPLATE_GET_TEMPLATE_LIST_REQUEST:
          "DATA_TEMPLATE_GET_TEMPLATE_LIST_REQUEST",
     DATA_TEMPLATE_GET_TEMPLATE_LIST_COMPLETE:
          "DATA_TEMPLATE_GET_TEMPLATE_LIST_COMPLETE",

     DATA_TEMPLATE_ADD_REQUEST: "DATA_TEMPLATE_ADD_REQUEST",
     DATA_TEMPLATE_ADD_COMPLETE: "DATA_TEMPLATE_ADD_COMPLETE",

     DATA_TEMPLATE_CREATE_BY_CSV_REQUEST: "DATA_TEMPLATE_CREATE_BY_CSV_REQUEST",
     DATA_TEMPLATE_CREATE_BY_CSV_COMPLETE:
          "DATA_TEMPLATE_CREATE_BY_CSV_COMPLETE",

     DATA_TEMPLATE_GET_ALL_SCHEME_ATTRIBUTE_REQUEST:
          "DATA_TEMPLATE_GET_ALL_SCHEME_ATTRIBUTE_REQUEST",
     DATA_TEMPLATE_GET_ALL_SCHEME_ATTRIBUTE_COMPLETE:
          "DATA_TEMPLATE_GET_ALL_SCHEME_ATTRIBUTE_COMPLETE",

     DATA_TEMPLATE_GET_ALL_TYPES_REQUEST: "DATA_TEMPLATE_GET_ALL_TYPES_REQUEST",
     DATA_TEMPLATE_GET_ALL_TYPES_COMPLETE:
          "DATA_TEMPLATE_GET_ALL_TYPES_COMPLETE",

     DATA_TEMPLATE_ADD_SCHEMA_VALUE_REQUEST:
          "DATA_TEMPLATE_ADD_SCHEMA_VALUE_REQUEST",
     DATA_TEMPLATE_ADD_SCHEMA_VALUE_COMPLETE:
          "DATA_TEMPLATE_ADD_SCHEMA_VALUE_COMPLETE",

     DATA_TEMPLATE_SCHEMA_VALUE_GET_REQUEST:
          "DATA_TEMPLATE_SCHEMA_VALUE_GET_REQUEST",
     DATA_TEMPLATE_SCHEMA_VALUE_GET_COMPLETE:
          "DATA_TEMPLATE_SCHEMA_VALUE_GET_COMPLETE",

     DATA_TEMPLATE_SCHEMA_VALUE_DELETE_REQUEST:
          "DATA_TEMPLATE_SCHEMA_VALUE_DELETE_REQUEST",
     DATA_TEMPLATE_SCHEMA_VALUE_DELETE_COMPLETE:
          "DATA_TEMPLATE_SCHEMA_VALUE_DELETE_COMPLETE",

     DATA_TEMPLATE_SCHEMA_VALUE_REORDER_REQUEST:
          "DATA_TEMPLATE_SCHEMA_VALUE_REORDER_REQUEST",
     DATA_TEMPLATE_SCHEMA_VALUE_REORDER_COMPLETE:
          "DATA_TEMPLATE_SCHEMA_VALUE_REORDER_COMPLETE",

     GET_DATA_TEMPLATE_JSON_SCHEMA_REQUEST:
          "GET_DATA_TEMPLATE_JSON_SCHEMA_REQUEST",
     GET_DATA_TEMPLATE_JSON_SCHEMA_COMPLETE:
          "GET_DATA_TEMPLATE_JSON_SCHEMA_COMPLETE",

     DATA_TEMPLATE_GET_VALUE_REQUEST: "DATA_TEMPLATE_GET_VALUE_REQUEST",
     DATA_TEMPLATE_GET_VALUE_COMPLETE: "DATA_TEMPLATE_GET_VALUE_COMPLETE",

     DATA_TEMPLATE_ADD_SCHEMA_RECORD_REQUEST:
          "DATA_TEMPLATE_ADD_SCHEMA_RECORD_REQUEST",
     DATA_TEMPLATE_ADD_SCHEMA_RECORD_COMPLETE:
          "DATA_TEMPLATE_ADD_SCHEMA_RECORD_COMPLETE",

     DATA_TEMPLATE_GET_SCHEMA_RECORD_REQUEST:
          "DATA_TEMPLATE_GET_SCHEMA_RECORD_REQUEST",
     DATA_TEMPLATE_GET_SCHEMA_RECORD_COMPLETE:
          "DATA_TEMPLATE_GET_SCHEMA_RECORD_COMPLETE",

     DATA_TEMPLATE_EDIT_SCHEMA_RECORD_REQUEST:
          "DATA_TEMPLATE_EDIT_SCHEMA_RECORD_REQUEST",
     DATA_TEMPLATE_EDIT_SCHEMA_RECORD_COMPLETE:
          "DATA_TEMPLATE_EDIT_SCHEMA_RECORD_COMPLETE",

     DATA_TEMPLATE_DELETE_REQUEST: "DATA_TEMPLATE_DELETE_REQUEST",
     DATA_TEMPLATE_DELETE_COMPLETE: "DATA_TEMPLATE_DELETE_COMPLETE",

     DATA_TEMPLATE_GET_REQUEST: "DATA_TEMPLATE_GET_REQUEST",
     DATA_TEMPLATE_GET_COMPLETE: "DATA_TEMPLATE_GET_COMPLETE",

     DATA_TEMPLATE_UPDATE_REQUEST: "DATA_TEMPLATE_UPDATE_REQUEST",
     DATA_TEMPLATE_UPDATE_COMPLETE: "DATA_TEMPLATE_UPDATE_COMPLETE",

     GET_DATA_TEMPLATE_LABELS_REQUEST: "GET_DATA_TEMPLATE_LABELS_REQUEST",
     GET_DATA_TEMPLATE_LABELS_COMPLETE: "GET_DATA_TEMPLATE_LABELS_COMPLETE",

     GET_DATA_TEMPLATE_TYPES_REQUEST: "GET_DATA_TEMPLATE_TYPES_REQUEST",
     GET_DATA_TEMPLATE_TYPES_COMPLETE: "GET_DATA_TEMPLATE_TYPES_COMPLETE",

     DATA_TEMPLATE_VALUE_UPDATE_REQUEST:'DATA_TEMPLATE_VALUE_UPDATE_REQUEST',
     DATA_TEMPLATE_VALUE_UPDATE_COMPLETE:'DATA_TEMPLATE_VALUE_UPDATE_COMPLETE',

     DATA_TEMPLATE_JSON_SCHEMA_DELETE_REQUEST:'DATA_TEMPLATE_JSON_SCHEMA_DELETE_REQUEST',
     DATA_TEMPLATE_JSON_SCHEMA_DELETE_COMPLETE:'DATA_TEMPLATE_JSON_SCHEMA_DELETE_COMPLETE',

     DATA_TEMPLATE_GET_USER_ACCOUNT_REQUEST:'DATA_TEMPLATE_GET_USER_ACCOUNT_REQUEST',
     DATA_TEMPLATE_GET_USER_ACCOUNT_COMPLETE:'DATA_TEMPLATE_GET_USER_ACCOUNT_COMPLETE',

     DATA_TEMPLATE_PARTICIPANT_USER_ACCOUNT_CREATE_REQUEST:'DATA_TEMPLATE_PARTICIPANT_USER_ACCOUNT_CREATE_REQUEST',
     DATA_TEMPLATE_PARTICIPANT_USER_ACCOUNT_CREATE_COMPLETE:'DATA_TEMPLATE_PARTICIPANT_USER_ACCOUNT_CREATE_COMPLETE',



     PARTICIPANT:'Participant',
     FACT_TABLE:'Fact Table',
};
